import { createSlice } from "@reduxjs/toolkit";

export const invoicesSlice = createSlice({
  name: "invoices",
  initialState: {
    loading: false,
    error: null,
    allInvoices: {},
    currentInvoices:{},
    dueInvoices:{},
    openInvoices:{},
    empAllInvoices:{},
    paidInvoices:{},
  },
  reducers: {
    getAllInvoicesStart(state, action) {
      state.loading = true;
      state.allInvoices = {};
    },
    getAllInvoicesSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.allInvoices = action.payload;
    },
    getAllInvoicesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.allInvoices = {};
    },
    addInvoicesStart(state,action){
       state.loading = false;
      state.error = null;
    },
    getDueInvoicesStart(state,action){
        state.loading = true;
       state.dueInvoices={};
    },
    getDueInvoiceFail(state,action){
      state.loading = false;
      state.error = action.payload;
      state.dueInvoices = {};
    },
    successDueInvoiceStart(state,action){
      state.loading = false;
      state.error = null;
       state.dueInvoices = action.payload;
    },
    getOpenInvoicesStart(state,action){
        state.loading = true;
       state.openInvoices={};
    },
    getPaidInvoicesStart(state,action){
    state.loading = true;
       state.paidInvoices={};
    },
    successPaidInvoiceStart(state,action){
       state.loading = false;
      state.error = null;
       state.paidInvoices = action.payload;
    },
    getOpenInvoiceFail(state,action){

    },
    successOpenInvoiceStart(state,action){
      state.loading = false;
      state.error = null;
       state.openInvoices = action.payload;
    },
    getEmpAllInvoicesStart(state,action){
      state.loading=false;
       state.error = null;
      state.empAllInvoices={}
    },
    successEmpAllInvoices(state,action){
        state.loading = false;
      state.error = null;
       state.empAllInvoices = action.payload;
    },
    getCurrentInvoiceStart(state,action){
       state.loading = true;
          state.error = null;
          state.currentInvoices={}
    },
    successGetCurrentInvoiceStart(state,action){
     state.loading = false;
          state.error = null;
          state.currentInvoices=action.payload
    },
    getFailCurrentInvoice(state,action){
        state.loading = false;
         state.error = action.payload;
          state.currentInvoices={}
    },
    clearInvoicesdata(state){
        state.loading = false;
      state.allInvoices = {};
      
    },

  },
});

export const {
    getAllInvoicesStart,
    getAllInvoicesSuccess,
    getAllInvoicesFailure,
   addInvoicesStart,
   getDueInvoicesStart,
   getDueInvoiceFail,
   successDueInvoiceStart,
   getOpenInvoicesStart,
   successOpenInvoiceStart,
   getEmpAllInvoicesStart,
   successEmpAllInvoices,
   getCurrentInvoiceStart,
   successGetCurrentInvoiceStart,
  getFailCurrentInvoice,
   clearInvoicesdata,
   getPaidInvoicesStart,
   successPaidInvoiceStart
} = invoicesSlice.actions;

export default invoicesSlice.reducer;
